import React from 'react'
import { Avatar, Badge, Space, Tag } from 'antd'
import { COLORS } from '../../constants'
import { useMyProfile } from '../../hooks/user/myprofile'
import { View } from '../../../styles/reactnative'
import { UserOutlined, WalletOutlined } from '@ant-design/icons'

const WalletTag = ({ walletid, type, symbol = '' }: any) => {
	return (
		<Space.Compact direction="horizontal" size={'small'}>
			<Space.Compact
				direction="horizontal"
				size={'small'}
				style={{ marginLeft: -5 }}>
				<Tag
					style={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						flexDirection: 'row',
						cursor: 'pointer',
						margin: 0,
						padding: '0px',
						paddingLeft: '5px',
						background: 'black',
						color: COLORS.white,
					}}>
					<WalletOutlined
						size={10}
						style={{
							marginRight: 5,
							color:
								type == 1
									? COLORS.lightRed
									: COLORS.primaryDark,
						}}
					/>
					{type == 9 ? '원화' : type == 1 ? '선물' : '현물'}
					<span style={{ background: '#444', padding: 3 }}>
						{walletid}
					</span>
					{symbol && (
						<span
							style={{
								background:
									type == 1
										? COLORS.lightRed
										: COLORS.primaryDark,
								padding: 3,
							}}>
							{symbol}
						</span>
					)}
				</Tag>
			</Space.Compact>
		</Space.Compact>
	)
}

export default React.memo(WalletTag)
